import React, { useEffect, useState } from "react";
import "./Home.css";
import { motion, AnimatePresence, useInView } from "framer-motion";
import gsap from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import Slider from 'react-slick';
import { useRef } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Heart } from 'lucide-react';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import halfLogo from '../../assets/images/Greylogo.png'; // Replace with your actual path
import primg from "../../assets/products/pr1.avif"
import primg2 from "../../assets/products/pr2.avif"
import primg3 from "../../assets/products/pr3.avif"
import primg4 from "../../assets/products/pr4.avif"
import primg5 from "../../assets/products/pr5.avif"
import primg6 from "../../assets/products/pr6.avif"
import { FaCheckCircle, FaTruck, FaUndoAlt, FaLock } from 'react-icons/fa';

import { getRecentProducts } from "../../services/api"; // adjust path if needed
import NewArrivals from "../newarrivals/NewArrivals";
import video1 from "../../assets/videos/vid1.mp4";
import video3 from "../../assets/videos/vid3.mp4";
import video4 from "../../assets/videos/vid4.mp4";


import kadab from '../../assets/images/kada.avif';
import kidshandmade from '../../assets/images/handmadebanner.avif';
import productsb from '../../assets/images/products.avif';
import banglesb from '../../assets/images/bangles.avif';
import kidssb from '../../assets/images/kidss.avif';
import kiddssb from '../../assets/images/kiddss.avif';
import handmade from '../../assets/images/handmade.avif';
import im1 from '../../assets/images/im1.avif';
import im2 from '../../assets/images/im2.avif';
import im3 from '../../assets/images/im3.avif';
import Footer from "../Footer/Footer";
import HorizontalScrollCards from "../../pages/HorizontalScrollCards/HorizontalScrollCards";
import mensjewell from "../../assets/stage1/mensjewel.avif"
import anklet from "../../assets/stage1/anklet.avif"
import bangles from "../../assets/stage1/bangles.avif"
import bracelet from "../../assets/stage1/bracelet.avif"

import earring from "../../assets/stage1/earring.avif"
import kada from "../../assets/stage1/kada.avif"

import neklace from "../../assets/stage1/necklace.avif"
import nosering from "../../assets/stage1/nosering.avif"

import pendants from "../../assets/stage1/pendants.avif"
import ring from "../../assets/stage1/rings.avif"
import solitarry from "../../assets/stage1/solitary.avif"
import chain from "../../assets/stage1/chains.avif"
import { FaTooth, FaClock, FaSmile, FaBolt } from "react-icons/fa"
import chairImage from "../../assets/images/backg.png"; // replace with your actual image path
import { FaShippingFast, FaMedal, FaGem, FaHandHoldingHeart } from 'react-icons/fa';
import { GiLaurelCrown, GiCutDiamond } from 'react-icons/gi';
import { BsFillGiftFill } from 'react-icons/bs';
import { MdPrecisionManufacturing } from 'react-icons/md';
import inside1 from '../../assets/shopimage/inim1.jpg'
import inside2 from '../../assets/shopimage/inim2.jpg'
import inside3 from '../../assets/shopimage/inim3.jpg'
import inside4 from '../../assets/shopimage/inim4.jpg'
import { IMAGE_PATH } from "../../services/api";
import FlashSaleBanner from "../FlashSaleBanner/FlashSaleBanner";
import JewelleryChipMarquee from "../JewelleryChipMarquee/JewelleryChipMarquee";

import FeaturedCollections from "../FeaturedCollections/FeaturedCollections";

import ProductCarousel from "../ProductCarousel/ProductCarousel";
import InspiredSpaces from "../InspiredSpaces/InspiredSpaces";
import AboutHero from "../AboutHero/AboutHero";
import TestimonialsSlider from "../TestimonialsSlider/TestimonialsSlider";
import FeaturedGrid from "../FeaturedGrid/FeaturedGrid";
import InstaMarquee from "../InstaMarquee/InstaMarquee";
import Newsletter from "../Newsletter/Newsletter";
import NewArrivalShowcase from "../newarrivals/NewArrivals";
import mobkada from "../../assets/images/11kada.avif";
import mobhandy from "../../assets/images/22kids.avif";
import mobproducts from "../../assets/images/33products.avif";
import mobbangles from "../../assets/images/44bangles.avif";
import mobkidss from "../../assets/images/55kids.avif";
import mobkkidds from "../../assets/images/66kids.avif";
import mobhandmade from "../../assets/images/77kids.avif";


import BannerCarousel from "../BannerCarousel/BannerCarousel";




// const priceRanges = [
//     { label: 'UNDER ₹999', link: '#' },
//     { label: '₹1,000 - ₹2,500', link: '#' },
//     { label: '₹5,000 - ₹7,500', link: '#' },
//     { label: 'Above ₹ 7,500', link: '#' },
//   ];

const priceRanges = [
    { label: 'UNDER ₹999', link: '/products?price=under-999' },
    { label: '₹1,000 - ₹2,500', link: '/products?price=1000-2500' },
    { label: '₹5,000 - ₹7,500', link: '/products?price=5000-7500' },
    { label: 'Below ₹10,000', link: '/products?price=below-10k' },
    // { label: '₹10,000 - ₹20,000', link: '/products?price=10k-20k' },
    // { label: '₹20,000 - ₹50,000', link: '/products?price=20k-50k' },
    // { label: 'Above ₹50,000', link: '/products?price=above-50k' },
];



const features = [
    {
        title: 'CERTIFIED SILVER PIECES',
        icon: <FaMedal className="icon silver" />,
        description: 'Certified and trusted purity in every piece.'
    },
    {
        title: 'TRUSTED LEGACY OF 60 YEARS',
        icon: <GiLaurelCrown className="icon legacy" />,
        description: 'Carrying forward decades of heritage and trust.'
    },
    {
        title: 'METICULOUSLY HANDCRAFTED BY ARTISANS',
        icon: <MdPrecisionManufacturing className="icon craft" />,
        description: 'Every detail carefully designed by skilled artisans.'
    },
    {
        title: 'FREE SHIPPING ACROSS ALL INDIA',
        icon: <BsFillGiftFill className="icon shipping" />,
        description: 'Enjoy complimentary shipping across India.'
    },
    {
        title: 'DESIGNS FOR LIFE’S SPECIAL MOMENTS',
        icon: <GiCutDiamond className="icon design" />,
        description: 'Celebrate every occasion with timeless beauty.'
    }
];




const CustomPrevArrow = ({ onClick }) => {
    return (
        <button
            className="custom-arrow prev-arrow"
            onClick={onClick}
            style={{
                position: "absolute",
                top: "50%",
                left: "20px",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                border: "none",
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                padding: "10px",
                cursor: "pointer",
                zIndex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "40px",
                height: "40px",
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                style={{ width: "20px", height: "20px", color: "#333" }}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                />
            </svg>
        </button>
    );
};

const CustomNextArrow = ({ onClick }) => {
    return (
        <button
            className="custom-arrow next-arrow"
            onClick={onClick}
            style={{
                position: "absolute",
                top: "50%",
                right: "20px",
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                border: "none",
                borderRadius: "50%",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                padding: "10px",
                cursor: "pointer",
                zIndex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "40px",
                height: "40px",
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                style={{ width: "20px", height: "20px", color: "#333" }}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                />
            </svg>
        </button>
    );
};



gsap.registerPlugin(ScrollTrigger); // Register ScrollTrigger once at the top

const galleryItems = {
    all: [
        { id: 1, image: "https://images.unsplash.com/photo-1611652022419-a9419f74343d?q=80&w=2188&auto=format&fit=crop", type: "rings" },
        { id: 2, image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?q=80&w=2187&auto=format&fit=crop", type: "necklaces" },
        { id: 3, image: "https://images.unsplash.com/photo-1629224316810-9d8805b95e76?q=80&w=2070&auto=format&fit=crop", type: "earrings" },
        { id: 4, image: "https://images.unsplash.com/photo-1618403088890-3d9ff6f4c8b1?q=80&w=2070&auto=format&fit=crop", type: "bracelets" },
        { id: 5, image: "https://images.unsplash.com/photo-1599459182681-c938b7f65344?q=80&w=1978&auto=format&fit=crop", type: "rings" },
        { id: 6, image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?q=80&w=2070&auto=format&fit=crop", type: "rings" },
        { id: 7, image: "https://images.unsplash.com/photo-1615655111426-258f7443765d?q=80&w=1972&auto=format&fit=crop", type: "necklaces" },
        { id: 8, image: "https://images.unsplash.com/photo-1599638518793-a7ba156f037a?q=80&w=2069&auto=format&fit=crop", type: "bracelets" }
    ],
    rings: [1, 5, 6],
    necklaces: [2, 7],
    earrings: [3],
    bracelets: [4, 8]
};

const categoriesData = [
    {
        id: 1,
        name: "Rings",
        image: primg6,
        count: 48
    },
    {
        id: 2,
        name: "Necklaces",
        image: primg,
        count: 36
    },
    {
        id: 3,
        name: "Earrings",
        image: primg4,
        count: 42
    },
    {
        id: 4,
        name: "Bracelets",
        image: primg3,
        count: 29
    },
    {
        id: 5,
        name: "Pendant",
        image: primg2,
        count: 23
    },
    {
        id: 6,
        name: "Chain",
        image: primg5,
        count: 18
    }
];
















const Home = () => {
    const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
    const [hoveredProductId, setHoveredProductId] = useState(null);

    const videoRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
    const videos = [video1, video3, video4];
    const [currentVideo, setCurrentVideo] = useState(0);
    const [products, setProducts] = useState([]);
    const sliderRef = useRef(null);

    const videoList = [video1, video3, video4];        // your video URLs
    // Desktop carousel: category banners (kadab, kidsb, etc.) — click goes to products with filter
    const imageList = [kadab, kidshandmade,handmade, productsb, banglesb, kidssb, kiddssb];

    // 2) State machine: first play videos, then images forever
    const [playbackPhase, setPlaybackPhase] = useState("video"); // "video" | "image"
    const [videoPointer, setVideoPointer] = useState(0);
    const [imagePointer, setImagePointer] = useState(0);
    const videoElementRef = useRef(null);
    const onSingleVideoEnded = () => {
        if (videoPointer < videoList.length - 1) {
            setVideoPointer((prev) => prev + 1);
        } else {
            setPlaybackPhase("image");
        }
    };

    // Loop images forever, 3s each
    useEffect(() => {
        if (playbackPhase !== "image" || imageList.length === 0) return;
        const timerId = setTimeout(() => {
            setImagePointer((prev) => (prev + 1) % imageList.length);
        }, 3000);
        return () => clearTimeout(timerId);
    }, [playbackPhase, imagePointer, imageList.length]);

    // Autoplay current video when pointer changes
    useEffect(() => {
        if (playbackPhase === "video" && videoElementRef.current) {
            videoElementRef.current.play().catch(() => { });
        }
    }, [playbackPhase, videoPointer]);







    // const initialCards = [
    //     { id: 1, title: " Solitaries", imgSrc: solitarry, 	 link: "#" },
    //     { id: 2, title: "Men's Jewellery", imgSrc: mensjewell, link: "#" },
    //     {id: 3, title: "Nose ring", imgSrc: nosering, link: "#" },
    //     {id: 4, title: "Anklets", imgSrc: anklet, link: "#" },
    //     { id: 5, title: "Rings", imgSrc: ring, link: "#" },
    //     { id: 6, title: "Pendents", imgSrc: pendants, link: "#" },
    //     { id: 7, title: "Necklaces", imgSrc: neklace, link: "#" },
    //     { id: 8, title: "Earrings", imgSrc: earring, link: "#" },
    //     { id: 9, title: "Bangles", imgSrc: bangles, link: "#" },
    //     { id: 10, title: "Bracelets", imgSrc: bracelet, link: "#" },
    //     { id: 11, title: "Chains", imgSrc: chain, link: "#" },
    //     { id: 12, title: "Kada", imgSrc:kada, link: "#" },

    // ];
    const initialCards = [
       
        { id: 4, title: "Anklets", imgSrc: anklet, link: "/products?category=Anklets" },
        { id: 5, title: "Rings", imgSrc: ring, link: "/products?category=Rings" },
        { id: 6, title: "Pendents", imgSrc: pendants, link: "/products?category=Pendents" },
        { id: 7, title: "Necklaces", imgSrc: neklace, link: "/products?category=Necklaces" },
        { id: 8, title: "Earrings", imgSrc: earring, link: "/products?category=Earrings" },
        { id: 9, title: "Bangles", imgSrc: bangles, link: "/products?category=Bangles" },
        { id: 10, title: "Bracelets", imgSrc: bracelet, link: "/products?category=Bracelets" },
        { id: 11, title: "Chains", imgSrc: chain, link: "/products?category=Chain" },
        { id: 12, title: "Kada", imgSrc: kada, link: "/products?category=Kada" },
        // { id: 1, title: "Solitaries", imgSrc: solitarry, link: "/products?category=Solitaries" },
        { id: 2, title: "Men's Jewellery", imgSrc: mensjewell, link: "/products?category=Men's Jewellery" },
        { id: 3, title: "Nose Ring", imgSrc: nosering, link: "/products?category=Nose Ring" },
    ];
    const navigate = useNavigate();

    const handleCategoryClick = (categoryName) => {
        navigate(`/products?category=${encodeURIComponent(categoryName)}`);
    };




    const imagesRef = useRef([]);
    const [hoveredId, setHoveredId] = useState(null);

    useEffect(() => {
        const triggers = [];

        setTimeout(() => {
            imagesRef.current.forEach((image) => {
                if (image) {
                    const trigger = gsap.fromTo(
                        image,
                        { y: 100, opacity: 0 },
                        {
                            y: 0,
                            opacity: 1,
                            duration: 4.0,
                            ease: "power3.out",
                            scrollTrigger: {
                                trigger: image,
                                start: "top 90%",
                                end: "top 30%",
                                scrub: true,
                            },
                        }
                    );
                    triggers.push(trigger.scrollTrigger);
                }
            });

            ScrollTrigger.refresh();
        }, 0);

        return () => {
            triggers.forEach((t) => t.kill());
        };
    }, []);



    useEffect(() => {
        playVideo(currentVideo); // Start the first video
    }, [currentVideo]);

    const playVideo = (index) => {
        if (videoRefs[index]?.current) {
            videoRefs[index].current.play();
        }
    };

    const handleVideoEnd = () => {
        // Move to the next video or loop back to the first
        const nextVideo = (currentVideo + 1) % videos.length;
        setCurrentVideo(nextVideo);
    };

    const [cardWidth, setCardWidth] = useState(0); // State to store card width dynamically


    const [isAnimating, setIsAnimating] = useState(false);
    const cardRef = useRef(null); // To get the card width dynamically

    useEffect(() => {
        // Update card width after the component mounts
        if (cardRef.current) {
            const calculatedWidth = cardRef.current.offsetWidth + 16; // 16px gap
            setCardWidth(calculatedWidth);
        }

        const handleResize = () => {
            // Recalculate card width on window resize
            if (cardRef.current) {
                const calculatedWidth = cardRef.current.offsetWidth + 16;
                setCardWidth(calculatedWidth);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (!isAnimating) {
                setIsAnimating(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isAnimating]);





    const images = [kadab, kidshandmade, handmade, productsb, banglesb, kidssb, kiddssb];

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true, // Enable arrow navigation
        prevArrow: <CustomPrevArrow />, // Use custom left arrow
        nextArrow: <CustomNextArrow />, // Use custom right arrow
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false, // Hide arrows on small screens
                    dots: true, // Show dots for navigation
                },
            },
        ],
    };

    const [activeTab, setActiveTab] = useState("all");

    const filteredItems = activeTab === "all"
        ? galleryItems.all
        : galleryItems.all.filter(item => item.type === activeTab);




    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const getProductStock = (product) => {
        if (product.variants && product.variants.length > 0) {
            return product.variants.reduce((sum, v) => sum + Number(v.quantity || 0), 0);
        }
        return Number(product.quantity ?? 0);
    };

    const getRecentList = (res) => {
        const raw = res?.data;
        if (Array.isArray(raw)) return raw;
        if (raw?.products && Array.isArray(raw.products)) return raw.products;
        if (raw?.recent && Array.isArray(raw.recent)) return raw.recent;
        return [];
    };

    useEffect(() => {
        const fetchRecent = async () => {
            try {
                const res = await getRecentProducts();
                const list = getRecentList(res);
                const inStock = list.filter((p) => {
                    const stock = getProductStock(p);
                    const hasExplicitStock = p.variants?.length > 0 || (p.quantity !== undefined && p.quantity !== null);
                    return stock > 0 || !hasExplicitStock;
                });
                setProducts(inStock);
            } catch (error) {
                console.error("Failed to fetch recent products:", error);
                setProducts([]);
            }
        };

        fetchRecent();
    }, []);
    const [tab, setTab] = useState("new"); // 'new' | 'hot'
    const [newProducts, setNewProducts] = useState([]);
    const [hotProducts, setHotProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    useEffect(() => {
        const fetchNew = async () => {
            try {
                setLoading(true);
                const res = await getRecentProducts();
                const list = getRecentList(res);
                const inStock = list.filter((p) => {
                    const stock = getProductStock(p);
                    const hasExplicitStock = p.variants?.length > 0 || (p.quantity !== undefined && p.quantity !== null);
                    return stock > 0 || !hasExplicitStock;
                });
                setNewProducts(inStock);
                setError("");
            } catch (e) {
                console.error("Failed to fetch recent products:", e);
                setError("Could not load New Arrivals.");
                setNewProducts([]);
            } finally {
                setLoading(false);
            }
        };
        fetchNew();
    }, []);

    // Lazy-fetch Hot Items when user switches tab the first time

    // Frontend-only Hot Items (use any images you like)
    // Frontend-only Hot Items (use any images you like)
    const hotProductsFrontend = [
        {
            id: "h1",
            productName: "Turquoise Toe Ring",
            category: "Hot · 92.5 Silver",
            cost: 2400,
            frontImage: primg, // you already imported primg, primg2... at top
        },
        {
            id: "h2",
            productName: "Vintage Gold Necklace",
            category: "Hot · Necklaces",
            cost: 5299,
            frontImage: primg2,
        },
        {
            id: "h3",
            productName: "Pearl Drop Earrings",
            category: "Hot · Earrings",
            cost: 1899,
            frontImage: primg3,
        },
        {
            id: "h4",
            productName: "Statement Bracelet",
            category: "Hot · Bracelets",
            cost: 2499,
            frontImage: primg4,
        },
    ];
    const [direction, setDirection] = useState(1);

    const slideVariants = {
        enter: (dir) => ({
            x: dir > 0 ? 150 : -150,
            opacity: 0
        }),
        center: {
            x: 0,
            opacity: 1
        },
        exit: (dir) => ({
            x: dir > 0 ? -150 : 150,
            opacity: 0
        })
    };
    const sectionRef = useRef(null);

    const isInView = useInView(sectionRef, {
        margin: "-10% 0px",
        once: false          // 👈 animate every time visible
    });
    const priceCardVariants = {
        hidden: { opacity: 0, y: 40 },
        show: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.18,
                duration: 0.55,
                ease: "easeOut",
            }
        })
    };
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 60 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };






    const getNewArrivalImage = (product) => {
        // Hot items (frontend)
        if (tab === "hot" && product.frontImage) {
            return product.frontImage;
        }

        // New arrivals (API)
        try {
            const imgs = JSON.parse(product.images || "[]");
            return imgs[0]
                ? `${IMAGE_PATH}${imgs[0]}`
                : "/images/default-product.jpg";
        } catch {
            return "/images/default-product.jpg";
        }
    };
    const getProductImage = (product) => {
        // HOT tab (frontend images)
        if (tab === "hot" && product.frontImage) {
            return product.frontImage;
        }

        // NEW tab (API images)
        if (!product.images) return "/images/default-product.jpg";

        try {
            const parsedImages =
                typeof product.images === "string"
                    ? JSON.parse(product.images)
                    : product.images;

            if (Array.isArray(parsedImages) && parsedImages.length > 0) {
                return `${IMAGE_PATH}${parsedImages[0]}`;
            }
        } catch (err) {
            console.error("Invalid images JSON:", product.images);
        }

        return "/images/default-product.jpg";
    };
    const ENABLE_VIDEO_PLAYLIST = false; // 👈 turn true later when needed
    useEffect(() => {
        const timer = setTimeout(() => {
            setImagePointer((prev) => (prev + 1) % imageList.length);
        }, 3000);

        return () => clearTimeout(timer);
    }, [imagePointer, imageList.length]);
 




    // Parent container controls the stagger
    const wrapallVariant = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.12, // ⬅️ left → right delay
            },
        },
    };

    // Each card animates bottom → up
    const cardVariant = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.45,
                ease: "easeOut",
            },
        },
    };



    // const newArrivals = products.filter(
    //     (p) => p.isNew === true
    // );

    // const hotItems = products.filter(
    //     (p) => p.isHot === true
    // );
    const mobileImageList = [
        mobkada,
        mobhandy,
        mobproducts,
        mobbangles,
        mobkidss,
        mobkkidds,
        mobhandmade
    ];



    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const onResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
const activeImageList = isMobile ? mobileImageList : imageList;
    // Banner click targets: Product type = category. Shop for = type. Handmade-style uses tag=handmade.
    // All handmade banners (desktop + mobile) now navigate with ?tag=handmade.
    const bannerLinks = [
        { filter: "category", value: "Kada" },
        { filter: "tag", value: "handmade" }, // kidshandmade visual → tag=handmade
        { filter: "tag", value: "handmade" }, // handmade visual → tag=handmade
        null,
        { filter: "category", value: "Bangles" },
        { filter: "type", value: "Kids" },
        { filter: "type", value: "Kids" },
    ];
    const mobileBannerLinks = [
        { filter: "category", value: "Kada" },
        { filter: "tag", value: "handmade" }, // mobhandy visual → tag=handmade
        null,
        { filter: "category", value: "Bangles" },
        { filter: "type", value: "Kids" },
        { filter: "type", value: "Kids" },
        { filter: "tag", value: "handmade" }, // mobhandmade visual → tag=handmade
    ];
    const activeBannerLinks = isMobile ? mobileBannerLinks : bannerLinks;
    const getBannerUrl = (link) => {
        if (!link) return "/products";
        return `/products?${link.filter}=${encodeURIComponent(link.value)}`;
    };
    return (
        <>

{/* 

            <motion.div
                className="wrapall container"
                variants={wrapallVariant}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.25 }}
            >
                <div className="menu-wrap">
                    {initialCards.map((card, index) => (
                        <motion.div
                            key={card.id}
                            className="cards"
                            ref={index === 0 ? cardRef : null}
                            variants={cardVariant}   // 👈 staggered item animation
                        >
                            <div className="menu-item">
                                <a href={card.link}>
                                    <div className="image-wrap">
                                        <img
                                            className="img-responsive-c"
                                            src={card.imgSrc}
                                            alt={card.title}
                                        />
                                    </div>
                                </a>
                            </div>

                            <p className="title">{card.title}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.div> */}



            
            <div className="container">
            <BannerCarousel
                imageList={imageList}
                mobileImageList={mobileImageList}
                bannerLinks={activeBannerLinks}
            />
            </div>
            {/* <div className="marco container">
                <div className="playlist-container">
                    <AnimatePresence mode="wait" custom={direction}>

                      
                        {!ENABLE_VIDEO_PLAYLIST && (
                            <motion.img
                                key={imagePointer}
                                src={activeImageList[imagePointer]}
                                alt=""
                                className={`playlist-media ${isMobile ? "mobile-banner" : "desktop-banner"}`}
                                custom={direction}
                                variants={slideVariants}
                                initial="enter"
                                animate="center"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            />
                        )}

                       
                        {ENABLE_VIDEO_PLAYLIST && playbackPhase === "video" && (
                            <motion.video
                                key={videoPointer}
                                ref={videoElementRef}
                                src={videoList[videoPointer]}
                                className="playlist-media"
                                onEnded={() => {
                                    setDirection(1);
                                    onSingleVideoEnded();
                                }}
                                muted
                                autoPlay
                                playsInline
                                custom={direction}
                                variants={slideVariants}
                                initial="enter"
                                animate="center"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                            />
                        )}

                    </AnimatePresence>
                </div>
            </div> */}


            {/* <div className="container">
                <JewelleryChipMarquee />

            </div> */}


            <div className="price-section container" ref={sectionRef}>
                <h2 className="price-title ourc">Shop By Price</h2>

                <div className="price-cards-container">
                    {priceRanges.map((range, index) => (
                        <Link to={range.link} key={index} className="price-card-link">

                            <motion.div
                                className="price-card"
                                variants={priceCardVariants}
                                initial="hidden"
                                animate={isInView ? "show" : "hidden"}
                                custom={index} // 👈 stagger animation
                            >
                                <img src={halfLogo} alt="" className="half-logo left" />

                                <div className="price-label">{range.label}</div>

                                <span className="shop-now-button">SHOP NOW</span>

                                <img src={halfLogo} alt="" className="half-logo right" />
                            </motion.div>

                        </Link>
                    ))}
                </div>
            </div>


            <div className="carousel-container container mobviewcoursel" style={{ position: "relative" }}>
                <Slider {...settings}>
                    {images.map((imgSrc, index) => (
                        <div key={index}>
                            <Link
                                to={getBannerUrl(activeBannerLinks[index])}
                                style={{ display: "block", cursor: "pointer" }}
                            >
                                <img
                                    src={imgSrc}
                                    alt={`Slide ${index + 1}`}
                                    style={{
                                        width: "100%",
                                        height: "300px",
                                        objectFit: "cover",
                                    }}
                                />
                            </Link>
                        </div>
                    ))}
                </Slider>
            </div>



           
            <motion.section
                className="na2-section"
                variants={{
                    hidden: { opacity: 0, y: 24 },
                    show: {
                        opacity: 1,
                        y: 0,
                        transition: { duration: 0.6, ease: "easeOut" },
                    },
                }}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.2 }}
            >
                <div className="na2-container container">
                    <div className="na2-header">
                        {/* HEADER */}
                        <div className="na2-title-wrap">
                            <h2 className="na2-title">
                                {tab === "new" ? "New Arrivals" : "Hot Items"}
                            </h2>
                            <p className="na2-subtitle">
                                Discover our latest jewelry pieces, crafted with precision and
                                designed for elegance.
                            </p>
                        </div>

                        {/* TABS */}
                        <div className="na2-tabs">
                            <button
                                className={`na2-tab ${tab === "new" ? "active" : ""}`}
                                onClick={() => setTab("new")}
                            >
                                New Arrivals
                            </button>
                            <button
                                className={`na2-tab ${tab === "hot" ? "active" : ""}`}
                                onClick={() => setTab("hot")}
                            >
                                Hot Items
                            </button>
                        </div>
                    </div>

                    {/* GRID */}
                    <motion.div
                        key={tab}
                        className="na2-grid"
                        variants={{
                            hidden: {},
                            show: { transition: { staggerChildren: 0.08 } },
                        }}
                        initial="hidden"
                        animate="show"
                    >
                        {/* PROMO CARD */}
                        <motion.div
                            className="na2-card na2-promo"
                            variants={{
                                hidden: { opacity: 0, y: 18 },
                                show: {
                                    opacity: 1,
                                    y: 0,
                                    transition: { duration: 0.45, ease: "easeOut" },
                                },
                            }}
                        >
                            <div className="na2-promo-content">
                                <h3>Exclusive Picks</h3>
                                <p>
                                    Discover timeless jewellery crafted to elevate your everyday
                                    elegance.
                                </p>
                                <button
                                    className="na2-promo-btn"
                                    onClick={() => navigate("/products")}
                                >
                                    Shop Now →
                                </button>
                            </div>
                        </motion.div>

                        {/* PRODUCT CARDS */}
                        {(tab === "new" ? products : hotProducts).map((product) => (
                            <motion.div
                                key={product.id}
                                className="na2-card"
                                onMouseEnter={() => setHoveredProductId(product.id)}
                                onMouseLeave={() => setHoveredProductId(null)}
                                whileHover={{ y: -4 }}
                                variants={{
                                    hidden: { opacity: 0, y: 18 },
                                    show: {
                                        opacity: 1,
                                        y: 0,
                                        transition: { duration: 0.45, ease: "easeOut" },
                                    },
                                }}
                            >
                                {/* IMAGE (3:4) */}
                                <div className="na2-image-wrap">
                                    <img
                                        src={getProductImage(product)}
                                        alt={product.productName}
                                        className="na2-image"
                                    />

                                    {/* HOVER CTA */}
                                    <div
                                        className={`na2-hover ${hoveredProductId === product.id ? "show" : ""
                                            }`}
                                    >
                                        <button
                                            className="na2-view-btn"
                                            onClick={() => navigate(`/product/${product.id}`)}
                                        >
                                            View Item
                                        </button>
                                    </div>
                                </div>

                                {/* INFO BELOW IMAGE */}
                                <div className="na2-info">
                                    <h4 className="na2-name">{product.productName ?? product.name}</h4>
                                    <span className="na2-price">₹{Number(product.displayPrice ?? product.cost ?? product.price ?? 0).toLocaleString()}</span>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </motion.section>


            <div className="flashsale container">
                <FlashSaleBanner />

            </div>
            {/* <div className="container">
                <JewelleryChipMarquee />

            </div> */}

            <FeaturedCollections />

            <ProductCarousel />

            <InspiredSpaces />
            <div className="cat">
                <section className="category-carousel-wrapper container">
                    <div className="category-carousel-container">
                        <div className="carousel-header">
                            <h2 className=" ourcshop">Shop By Category</h2>
                            <p className="carousel-subtitle">Browse our extensive collection of fine jewelry by category</p>
                        </div>

                        <Slider {...sliderSettings}>
                            {categoriesData.map(category => (
                                <div key={category.id} className="category-card">
                                    <div
                                        className="category-card-img-wrapper"
                                        onMouseEnter={() => setHoveredCategoryId(category.id)}
                                        onMouseLeave={() => setHoveredCategoryId(null)}
                                    >
                                        <img src={category.image} alt={category.name} className="category-card-img" />
                                        <div className="category-card-overlay" />
                                        <div className="category-card-content">
                                            <div className={`category-card-button ${hoveredCategoryId === category.id ? 'show' : ''}`}>
                                                <button onClick={() => handleCategoryClick(category.name)}>View Collection</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>


                    </div>
                </section>
            </div>

            <div className="covaerall">
                <div className="product-page1  container">
                    <h1 className="ourc">Our Collections</h1>
                    <p>Discover our carefully curated collections that blend traditional craftsmanship with contemporary design.</p>
                    {/* Image Section with Tectonic Scroll Animation */}
                    <div className="product-page">
                        <section className="image-gallery">
                            <Link to="/products?collection=CZ Collections" className="image-box" ref={(el) => (imagesRef.current[0] = el)}>
                                <img src={im1} alt="Heritage Collection" />
                            </Link>
                            <Link to="/products?collection=GOD Pendants" className="image-box" ref={(el) => (imagesRef.current[1] = el)}>
                                <img src={im2} alt="Modern Collection" />
                            </Link>
                            <Link to="/products?collection=Cuban Collection" className="image-box" ref={(el) => (imagesRef.current[2] = el)}>
                                <img src={im3} alt="Bridal Collection" />
                            </Link>
                        </section>

                    </div>
                </div>
            </div>


          
<div className="container">
            <AboutHero />
            </div>
            <div className="assured-container container ">
                <h1 className="page-title ourc">Why Choose Us</h1>
                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div className="feature-card" key={index}>
                            {feature.icon}
                            <h2 className="feature-title">{feature.title}</h2>
                            <p className="feature-description">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            
            <TestimonialsSlider />
            {/* <FeaturedGrid /> */}

            {/* <InstaMarquee /> */}




          





            {/* <section className="store-section">
                <h2 className="store-heading ourc">Visit Our Store</h2>
                <div className="store-grid">
                    {stores.map((store, idx) => (
                        <div className="store-card" key={idx}>
                            <img src={store.image} alt={store.name} className="store-image" />
                            <h3 className="store-name">{store.name}</h3>
                            <p className="store-location">{store.location}</p>
                        </div>
                    ))}
                </div>
            </section> */}

            <Newsletter />

            <Footer />

        </>
    );
};

export default Home;
